import api from "./api";

// ─── Folder Operations ───

export const createFolder = (data) => api.post("/documents/folders", data);

export const getFolderTree = (params) => api.get("/documents/folders", { params });

export const renameFolder = (id, data, params) =>
  api.patch(`/documents/folders/${id}`, data, { params });

export const deleteFolder = (id, params) =>
  api.delete(`/documents/folders/${id}`, { params });

export const moveFolder = (id, data, params) =>
  api.post(`/documents/folders/${id}/move`, data, { params });

// ─── Upload Operations ───

export const uploadDocument = (formData, params) =>
  api.post("/documents/upload", formData, { params });

export const bulkUpload = (formData, params) =>
  api.post("/documents/bulk-upload", formData, { params });

// ─── Browse, Search, Download ───

export const listDocuments = (params) =>
  api.get("/documents", { params });

export const searchDocuments = (params) =>
  api.get("/documents/search", { params });

export const getDocumentDetail = (id, params) =>
  api.get(`/documents/${id}`, { params });

export const downloadDocument = (id, params) =>
  api.get(`/documents/${id}/download`, { params });

// ─── Edit, Move, Delete ───

export const updateDocument = (id, data, params) =>
  api.patch(`/documents/${id}`, data, { params });

export const moveDocument = (id, data, params) =>
  api.post(`/documents/${id}/move`, data, { params });

export const deleteDocument = (id, params) =>
  api.delete(`/documents/${id}`, { params });
